// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"ban_a"};